// Champs spécifiques par catégorie

export const CATEGORY_FIELDS = {
  // ========== VÉHICULES ==========
  
  'Auto - Moto': {
    fields: [
      {
        name: 'model',
        label: 'Modèle',
        type: 'text',
        required: false,
        placeholder: 'Ex: Corolla, C-Class, CBR 600...'
      },
      {
        name: 'kilometrage',
        label: 'Kilométrage',
        type: 'text',
        required: true,
        placeholder: '50000 km'
      },
      {
        name: 'carburant',
        label: 'Type de carburant',
        type: 'select',
        required: true,
        options: ['Essence', 'Diesel', 'Hybride', 'Électrique', 'GPL']
      },
      {
        name: 'transmission',
        label: 'Transmission',
        type: 'select',
        required: true,
        options: ['Manuelle', 'Automatique', 'Semi-automatique']
      }
    ]
  },

  'Véhicules utilitaires': {
    fields: [
      {
        name: 'model',
        label: 'Modèle',
        type: 'text',
        required: false,
        placeholder: 'Ex: Transit, Sprinter, Master...'
      },
      {
        name: 'kilometrage',
        label: 'Kilométrage',
        type: 'text',
        required: true,
        placeholder: '80000 km'
      },
      {
        name: 'carburant',
        label: 'Type de carburant',
        type: 'select',
        required: true,
        options: ['Essence', 'Diesel']
      },
      {
        name: 'transmission',
        label: 'Transmission',
        type: 'select',
        required: true,
        options: ['Manuelle', 'Automatique']
      }
    ]
  },

  'Camions & Engins': {
    fields: [
      {
        name: 'model',
        label: 'Modèle',
        type: 'text',
        required: false,
        placeholder: 'Ex: MAN, Volvo, Caterpillar...'
      },
      {
        name: 'kilometrage',
        label: 'Kilométrage / Heures',
        type: 'text',
        required: false,
        placeholder: '120000 km ou 5000h'
      },
      {
        name: 'carburant',
        label: 'Type de carburant',
        type: 'select',
        required: false,
        options: ['Diesel', 'Essence', 'Électrique', 'Hybride']
      }
    ]
  },

  // ========== IMMOBILIER ==========

  'Immobilier': {
    fields: [
      {
        name: 'Superficie',  // Correspond à la colonne 'Superficie' dans posts
        label: 'Surface',
        type: 'number',
        required: true,
        placeholder: '100',
        suffix: 'm²'
      },
      {
        name: 'nombrePieceMaison',  // Correspond à la colonne 'nombrePieceMaison' dans posts
        label: 'Nombre de pièces',
        type: 'number',
        required: false,
        placeholder: '3'
      },
      {
        name: 'nombreSalleBain',  // Correspond à la colonne 'nombreSalleBain' dans posts
        label: 'Nombre de salles de bain',
        type: 'number',
        required: false,
        placeholder: '2'
      },
      {
        name: 'situationGeographique',  // Correspond à la colonne 'situationGeographique' dans posts
        label: 'Situation géographique',
        type: 'text',
        required: true,
        placeholder: 'Ex: Cocody, Marcory, Yopougon...'
      },
      {
        name: 'apartir_de',  // Correspond à la colonne 'apartir_de' dans posts
        label: 'Prix de départ / Loyer mensuel',
        type: 'number',
        required: false,
        placeholder: '150000',
        suffix: 'FCFA'
      }
    ]
  },

  'Téléphones': {
    fields: [
      {
        name: 'model',
        label: 'Modèle',
        type: 'text',
        required: false,
        placeholder: 'Ex: iPhone 15 Pro, Galaxy S24 Ultra...'
      }
    ]
  },

  'Smartphones': {
    fields: [
      {
        name: 'model',
        label: 'Modèle',
        type: 'text',
        required: false,
        placeholder: 'Ex: iPhone 15, Xiaomi 13...'
      }
    ]
  },

  'Tablettes': {
    fields: [
      {
        name: 'model',
        label: 'Modèle',
        type: 'text',
        required: false,
        placeholder: 'Ex: iPad Pro, Galaxy Tab S9...'
      }
    ]
  },

  'Informatique': {
    fields: [
      {
        name: 'model',
        label: 'Modèle',
        type: 'text',
        required: false,
        placeholder: 'Ex: Dell XPS 15, HP Pavilion...'
      }
    ]
  },

  'Ordinateurs portables': {
    fields: [
      {
        name: 'model',
        label: 'Modèle',
        type: 'text',
        required: false,
        placeholder: 'Ex: MacBook Pro M3, ThinkPad X1...'
      }
    ]
  },

  'Ordinateurs de bureau': {
    fields: [
      {
        name: 'model',
        label: 'Modèle',
        type: 'text',
        required: false,
        placeholder: 'Ex: iMac, Dell Optiplex...'
      }
    ]
  },

  'Appartements': {
    fields: [
      {
        name: 'Superficie',
        label: 'Surface',
        type: 'number',
        required: true,
        placeholder: '85',
        suffix: 'm²'
      },
      {
        name: 'nombrePieceMaison',
        label: 'Nombre de pièces',
        type: 'number',
        required: true,
        placeholder: '3'
      },
      {
        name: 'nombreSalleBain',
        label: 'Salles de bain',
        type: 'number',
        required: false,
        placeholder: '1'
      },
      {
        name: 'situationGeographique',
        label: 'Situation géographique',
        type: 'text',
        required: true,
        placeholder: 'Ex: Plateau, Marcory, 2 Plateaux...'
      },
      {
        name: 'apartir_de',
        label: 'Prix / Loyer',
        type: 'number',
        required: false,
        placeholder: '150000',
        suffix: 'FCFA'
      }
    ]
  },

  'Terrains': {
    fields: [
      {
        name: 'Superficie',
        label: 'Surface du terrain',
        type: 'number',
        required: true,
        placeholder: '500',
        suffix: 'm²'
      },
      {
        name: 'situationGeographique',
        label: 'Situation géographique',
        type: 'text',
        required: true,
        placeholder: 'Ex: Grand Bassam, Bingerville...'
      },
      {
        name: 'apartir_de',
        label: 'Prix du terrain',
        type: 'number',
        required: false,
        placeholder: '10000000',
        suffix: 'FCFA'
      }
    ]
  },

  'Bureaux & Commerces': {
    fields: [
      {
        name: 'Superficie',
        label: 'Surface',
        type: 'number',
        required: true,
        placeholder: '120',
        suffix: 'm²'
      },
      {
        name: 'nombrePieceMaison',
        label: 'Nombre de pièces/bureaux',
        type: 'number',
        required: false,
        placeholder: '5'
      },
      {
        name: 'situationGeographique',
        label: 'Situation géographique',
        type: 'text',
        required: true,
        placeholder: 'Ex: Plateau, Zone 4, Treichville...'
      },
      {
        name: 'apartir_de',
        label: 'Loyer mensuel',
        type: 'number',
        required: false,
        placeholder: '500000',
        suffix: 'FCFA'
      }
    ]
  },

  'Locations': {
    fields: [
      {
        name: 'Superficie',
        label: 'Surface',
        type: 'number',
        required: true,
        placeholder: '75',
        suffix: 'm²'
      },
      {
        name: 'nombrePieceMaison',
        label: 'Nombre de pièces',
        type: 'number',
        required: true,
        placeholder: '2'
      },
      {
        name: 'nombreSalleBain',
        label: 'Salles de bain',
        type: 'number',
        required: false,
        placeholder: '1'
      },
      {
        name: 'situationGeographique',
        label: 'Situation géographique',
        type: 'text',
        required: true,
        placeholder: 'Ex: Cocody, Yopougon...'
      },
      {
        name: 'apartir_de',
        label: 'Loyer mensuel',
        type: 'number',
        required: true,
        placeholder: '100000',
        suffix: 'FCFA'
      }
    ]
  },

  'Colocation': {
    fields: [
      {
        name: 'Superficie',
        label: 'Surface de la chambre',
        type: 'number',
        required: false,
        placeholder: '20',
        suffix: 'm²'
      },
      {
        name: 'nombrePieceMaison',
        label: 'Nombre total de colocataires',
        type: 'number',
        required: false,
        placeholder: '3'
      },
      {
        name: 'situationGeographique',
        label: 'Situation géographique',
        type: 'text',
        required: true,
        placeholder: 'Ex: Abobo, Adjamé...'
      },
      {
        name: 'apartir_de',
        label: 'Part mensuelle',
        type: 'number',
        required: true,
        placeholder: '50000',
        suffix: 'FCFA'
      }
    ]
  },

  // ========== TÉLÉPHONES & HIGH-TECH ==========

  'Téléphones': {
    fields: [
      {
        name: 'marque',
        label: 'Marque',
        type: 'select',
        required: true,
        options: [
          'Apple', 'Samsung', 'Huawei', 'Xiaomi', 'Oppo', 'Vivo', 
          'OnePlus', 'Google', 'Sony', 'Nokia', 'Motorola', 'Autre'
        ]
      },
      {
        name: 'modele',
        label: 'Modèle',
        type: 'text',
        required: false,
        placeholder: 'Ex: iPhone 14, Galaxy S23...'
      },
      {
        name: 'capacite',
        label: 'Capacité de stockage',
        type: 'select',
        required: true,
        options: ['32 Go', '64 Go', '128 Go', '256 Go', '512 Go', '1 To']
      },
      {
        name: 'ram',
        label: 'Mémoire RAM',
        type: 'select',
        required: false,
        options: ['2 Go', '3 Go', '4 Go', '6 Go', '8 Go', '12 Go', '16 Go']
      },
      {
        name: 'couleur',
        label: 'Couleur',
        type: 'select',
        required: false,
        options: ['Noir', 'Blanc', 'Bleu', 'Rouge', 'Vert', 'Or', 'Argent', 'Rose', 'Violet', 'Autre']
      },
      {
        name: 'dualeSimm',
        label: 'Double SIM',
        type: 'select',
        required: false,
        options: ['Oui', 'Non']
      }
    ]
  },

  'Informatique': {
    fields: [
      {
        name: 'model',
        label: 'Modèle',
        type: 'text',
        required: false,
        placeholder: 'Ex: Dell XPS 15, HP Pavilion...'
      }
    ]
  },

  'Ordinateurs portables': {
    fields: [
      {
        name: 'model',
        label: 'Modèle',
        type: 'text',
        required: false,
        placeholder: 'Ex: MacBook Pro M3, ThinkPad X1...'
      }
    ]
  },

  'Ordinateurs de bureau': {
    fields: [
      {
        name: 'model',
        label: 'Modèle',
        type: 'text',
        required: false,
        placeholder: 'Ex: iMac, Dell Optiplex...'
      }
    ]
  },

  // ========== ÉLECTROMÉNAGER ==========

  'Électroménager': {
    fields: [
      {
        name: 'model',
        label: 'Modèle',
        type: 'text',
        required: false,
        placeholder: 'Ex: Samsung RF23, LG Double Door...'
      }
    ]
  },

  'Réfrigérateurs & Congélateurs': {
    fields: [
      {
        name: 'model',
        label: 'Modèle',
        type: 'text',
        required: false,
        placeholder: 'Ex: Samsung RF23, Hisense 350L...'
      }
    ]
  },

  'Climatiseurs & Ventilateurs': {
    fields: [
      {
        name: 'model',
        label: 'Modèle',
        type: 'text',
        required: false,
        placeholder: 'Ex: LG 12000 BTU, Samsung Split...'
      }
    ]
  },

  'Appareils de cuisine': {
    fields: [
      {
        name: 'model',
        label: 'Modèle',
        type: 'text',
        required: false,
        placeholder: 'Ex: Moulinex Cookeo, Kenwood Chef...'
      }
    ]
  },

  // ========== AGRICULTURE ==========

  'Agriculture': {
    fields: [
      {
        name: 'model',
        label: 'Description',
        type: 'text',
        required: false,
        placeholder: 'Détails supplémentaires...'
      }
    ]
  },

  'Produits agricoles': {
    fields: [
      {
        name: 'model',
        label: 'Type de produit',
        type: 'text',
        required: false,
        placeholder: 'Ex: Cacao, Café, Maïs...'
      }
    ]
  },

  'Matériel agricole': {
    fields: [
      {
        name: 'model',
        label: 'Modèle',
        type: 'text',
        required: false,
        placeholder: 'Ex: Tracteur John Deere, Moissonneuse...'
      }
    ]
  }
}

// Helper pour obtenir les champs d'une catégorie
export const getCategoryFields = (category) => {
  return CATEGORY_FIELDS[category] || null
}
